import { render, staticRenderFns } from "./StandardModal.vue?vue&type=template&id=17cd0602&"
import script from "./StandardModal.vue?vue&type=script&lang=js&"
export * from "./StandardModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports